/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'ignorance',
    quality: 0,
    learning: -2,
    perception: -2,
    willpower: 3
}